// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let StatelyView
export default StatelyView = (function () {
  StatelyView = class StatelyView extends (
    require("lib/static-shim").default(require("./view").default)
  ) {
    constructor(...args) {
      super(...args)
      this.render = this.render.bind(this)
      this.onTriggerClicked = this.onTriggerClicked.bind(this)
      this.onStateChangeEvent = this.onStateChangeEvent.bind(this)
    }

    static initClass() {
      this.prototype.state = null
      this.prototype.states = {}
      this.prototype.transition = false

      this.prototype._stateIndex = {}
      this.prototype._stateView = null
    }

    initialize() {
      super.initialize()
      this.state = new window.BackboneUtils.Model()

      for (let k in this.states) {
        const v = this.states[k]
        this._stateIndex[k] = {
          name: k,
          view: v
        }
      }
      return (this.model.view = this)
    }

    render() {
      super.render()

      if (this.selectedState) {
        this._out()
      }

      this.selectedState = this._stateIndex[this.state.get("state")]
      this._stateView = this.getStateView()
      this._stateView.on("state-change", this.onStateChangeEvent)
      this.renderStateView(this._stateView)

      this._in()
      return this
    }

    bindTriggers() {
      const $triggers = this.$el.find("*[data-trigger-state]")
      return $triggers.on("click", this.onTriggerClicked)
    }

    unbindTriggers() {
      const $triggers = this.findEl("*[data-trigger-state]")
      return $triggers.off("click", this.onTriggerClicked)
    }

    onTriggerClicked(e) {
      e.preventDefault()
      const state = $(e.currentTarget).data("trigger-state")
      return this._stateView.trigger("state-change", state)
    }

    stateViewContainer() {
      return this.el
    }

    renderStateView(stateView) {
      const el = this.stateViewContainer()
      return this.getStateViewContainer().html(stateView.render().el)
    }

    getStateViewContainer() {
      return this.$el
    }

    onStateChangeEvent(state) {
      this.state.set("state", state)
      return this.render()
    }

    changeState(state) {
      this.state.set("state", state)
      return this.render()
    }

    _out() {
      $(this.el).removeClass(this.selectedState.name)
      if (this._stateView.out != null) {
        this._stateView.out()
      }
      this._stateView.undelegateEvents()
      this._stateView.off("state-change", this.onStateChangeEvent)
      if (this._stateView.destroy != null) {
        return this._stateView.destroy()
      }
    }

    _in() {
      $(this.el).addClass(this.selectedState.name)
      if (this._stateView.in != null) {
        return this._stateView.in()
      }
    }

    getStateView() {
      let v = this.selectedState.view
      if ($.type(v) === "function") {
        const isViewClass = v.prototype instanceof Backbone.View
        if (!isViewClass) {
          // bind to the view scope!
          try {
            v = _.bind(v, this)()
            return v
          } catch (e) {
            if (e instanceof TypeError) {
              // likely attempting to call class as a function as our shimmed Backbone Views are not instances of Backone.View
              console.warn(`Most likely OK to ignore: ${e}`)
            } else {
              throw new Error(e)
            }
          }
        }
      }
      if ($.type(v) === "string" && $.type(this[v]) === "function") {
        v = this[v]()
      }
      return this.instantiateStateView(v)
    }

    instantiateStateView(StateView) {
      return new StateView({ model: this.model })
    }
  }
  StatelyView.initClass()
  return StatelyView
})()
